import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { accountDevicesRoute, devicesRoute } from 'src/app/app-routing.module';
import { ConfirmationDialogService } from 'src/app/common-components/confirmation-dialog/confirmation-dialog.service';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { DeviceDetailSaveModel } from '../../device-details/models/device-detail-save.model';
import { AddDeviceApiService } from '../services/add-device-api.service';
import * as AddDeviceActions from './add-device.actions';

@Injectable()
export class AddDeviceEffects {
   createDevice$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddDeviceActions.createDevice),
         switchMap((action) => {
            const deviceToSave: DeviceDetailSaveModel = {
               ...action.device,
            };
            return this.addDeviceApiService.create(deviceToSave).pipe(
               map((executionResult) => {
                  return AddDeviceActions.createDeviceSuccess({
                     deviceId: executionResult.data.device.deviceId,
                     deviceType: executionResult.data.device.deviceTypeId,
                     accountId: executionResult.data.device.accountId,
                  });
               }),
               catchError((error) => {
                  return of(AddDeviceActions.createDeviceFailure(error));
               })
            );
         })
      );
   });

   createDeviceAndAddAnother$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddDeviceActions.createDeviceAndAddAnother),
         switchMap((action) => {
            const deviceToSave: DeviceDetailSaveModel = {
               ...action.device,
            };
            return this.addDeviceApiService.create(deviceToSave).pipe(
               map((executionResult) => {
                  return AddDeviceActions.createDeviceAndAddAnotherSuccess({
                     deviceId: executionResult.data.device.deviceId,
                     deviceType: executionResult.data.device.deviceTypeId,
                     accountId: executionResult.data.device.accountId,
                     accountName: action.accountName,
                  });
               }),
               catchError((error) => {
                  return of(AddDeviceActions.createDeviceAndAddAnotherFailure(error));
               })
            );
         })
      );
   });

   createDeviceSuccess$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddDeviceActions.createDeviceSuccess),
         tap((result) => {
            this.dialogService.closeFormComponent();
            const route =
               result.accountId == null
                  ? `/${devicesRoute}/${result.deviceId}`
                  : `/${accountDevicesRoute}/${result.deviceId}`;
            this.router.navigate([route]);
            this.snackbar.open(`Device ${result.deviceType} Created`);
         }),
         map((result) => AddDeviceActions.setDeviceTypeOnForm({ deviceType: result.deviceType }))
      );
   });

   createDeviceAndAddAnotherSuccess$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddDeviceActions.createDeviceAndAddAnotherSuccess),
         tap((result) => {
            this.snackbar.open(`Device ${result.deviceType} Created`);
         }),
         map((result) => AddDeviceActions.setDeviceTypeOnForm({ deviceType: result.deviceType }))
      );
   });

   constructor(
      private actions$: Actions,
      private addDeviceApiService: AddDeviceApiService,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private confirmationService: ConfirmationDialogService,
      private router: Router
   ) {}
}
